import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "busy-indicator-container"
}
const _hoisted_2 = { class: "table-controls" }
const _hoisted_3 = { class: "last-updated" }

import isNil from 'lodash/isNil'
import { computed, onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'

import BusyIndicator from '@/components/common/BusyIndicator.vue'
import CardContainer from '@/components/common/CardContainer.vue'
import NotificationBanner from '@/components/common/NotificationBanner.vue'
import PrintButton from '@/components/common/PrintButton.vue'
import LeagueRoundMatchesTable from '@/components/widgets/public/LeagueRoundMatchesTable.vue'
import LeagueRundownTable from '@/components/widgets/public/LeagueRundownTable.vue'
import LeagueStandingsTable from '@/components/widgets/public/LeagueStandingsTable.vue'
import { useLeaguesStore } from '@/store/public/leagues'
import { getErrorMessage } from '@/utils/error-handling'
import { formatDate } from '@/utils/format'


export default /*@__PURE__*/_defineComponent({
  __name: 'LeagueRoundStandingsView',
  setup(__props) {

const leagues = useLeaguesStore()
const route = useRoute()

const errorMessage = ref<string | null>(null)
const isLoading = ref<boolean>(false)

const selectedRoundSectionNumber = computed<string>((): string => {
  if (isNil(leagues.selectedRound)) {
    return '?'
  }

  if (!isNil(leagues.selectedRound.section_number_extra)) {
    return `${leagues.selectedRound.section_number} / ${leagues.selectedRound.section_number_extra}`
  }

  return String(leagues.selectedRound.section_number)
})

onMounted(async () => {
  errorMessage.value = null
  isLoading.value = true

  try {
    await leagues.selectRoundById(route.params.round as string)
    await leagues.fetchLeagueRoundStandings()
  } catch (e) {
    const message = getErrorMessage(e as Error)
    console.error(`Failed fetching league standings: ${message}`)
    errorMessage.value = message
  }

  isLoading.value = false
})

return (_ctx: any,_cache: any) => {
  return (isLoading.value)
    ? (_openBlock(), _createElementBlock("h1", _hoisted_1, [
        _createVNode(BusyIndicator)
      ]))
    : (errorMessage.value)
      ? (_openBlock(), _createBlock(NotificationBanner, {
          key: 1,
          message: errorMessage.value,
          "is-danger": ""
        }, null, 8, ["message"]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(PrintButton)
          ]),
          _createVNode(CardContainer, {
            title: 
        _ctx.$t('leagues.labels.section-round', {
          section: selectedRoundSectionNumber.value,
          separator: '»',
          round: _unref(leagues).selectedRound?.number ?? '?',
        })
      
          }, {
            default: _withCtx(() => [
              ((_unref(leagues).selectedRound?.standings?.rows ?? []).length === 0)
                ? (_openBlock(), _createBlock(NotificationBanner, {
                    key: 0,
                    message: _ctx.$t('leagues.errors.no-round-results'),
                    "is-warning": ""
                  }, null, 8, ["message"]))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("h4", null, [
                      _createTextVNode(_toDisplayString(_ctx.$t('leagues.labels.last-updated')) + ": ", 1),
                      _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(formatDate)(new Date(_unref(leagues).selectedRound?.standings?.timestamp))), 1)
                    ]),
                    ((_unref(leagues).selectedRound?.standings?.matches ?? []).length > 0)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("h4", null, _toDisplayString(_ctx.$t('leagues.labels.matches')), 1),
                          _createVNode(LeagueRoundMatchesTable, {
                            rows: _unref(leagues).selectedRound?.standings?.matches,
                            "round-id": _unref(leagues).selectedRound?.id
                          }, null, 8, ["rows", "round-id"])
                        ], 64))
                      : _createCommentVNode("", true),
                    _createElementVNode("h4", null, _toDisplayString(_ctx.$t('leagues.labels.section', {
              section: _unref(leagues).selectedRound?.section_number,
            })), 1),
                    _createVNode(LeagueStandingsTable, {
                      rows: _unref(leagues).selectedRound?.standings?.rows
                    }, null, 8, ["rows"]),
                    ((_unref(leagues).selectedRound?.standings?.rundown ?? []).length > 0)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createElementVNode("h4", null, _toDisplayString(_ctx.$t('leagues.labels.rundown')), 1),
                          _createVNode(LeagueRundownTable, {
                            rows: _unref(leagues).selectedRound?.standings?.rundown
                          }, null, 8, ["rows"])
                        ], 64))
                      : _createCommentVNode("", true),
                    (_unref(leagues).selectedRound?.section_number_extra)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          _createElementVNode("h4", null, _toDisplayString(_ctx.$t('leagues.labels.section', {
                section: _unref(leagues).selectedRound?.section_number_extra,
              })), 1),
                          _createVNode(LeagueStandingsTable, {
                            rows: _unref(leagues).selectedRound?.standings?.rows_extra
                          }, null, 8, ["rows"]),
                          (
              (_unref(leagues).selectedRound?.standings?.rundown_extra ?? []).length > 0
            )
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createElementVNode("h4", null, _toDisplayString(_ctx.$t('leagues.labels.rundown')), 1),
                                _createVNode(LeagueRundownTable, {
                                  rows: _unref(leagues).selectedRound?.standings?.rundown_extra
                                }, null, 8, ["rows"])
                              ], 64))
                            : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true)
                  ], 64))
            ]),
            _: 1
          }, 8, ["title"])
        ], 64))
}
}

})